
    import '/mnt/src/components/Search/index.md?watch=parent';
    export const demoIndex = {
  ids: ["search-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Search/index.md?type=demo')
};